import { InstructorAssessmentView } from "./InstructorAssessmentView";
import { StudentAssessmentView } from "./StudentAssessmentView";

import { SectionScoreTableProvider } from "providers/SectionScoreTableProvider";
import { useCapabilities } from "store/capability-hooks";
import { useAppSelector } from "store/index";
import { selectCurrentUserId } from "store/selectors";

export const SectionAssessmentMainView = () => {
  const currentUserId = useAppSelector(selectCurrentUserId);
  const { canParticipateInSection, canAuthorSection } = useCapabilities();

  if (!currentUserId) {
    return null;
  }

  return (
    <SectionScoreTableProvider>
      <div className="flex flex-col gap-6 text-xs">
        {canParticipateInSection ? (
          <StudentAssessmentView userId={currentUserId} />
        ) : canAuthorSection ? (
          <InstructorAssessmentView />
        ) : null}
      </div>
    </SectionScoreTableProvider>
  );
};
